var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ActBaseBottom",style:(_vm.option&&_vm.option.style)},[_vm._v("本次活动在法律允许范围内，最终解释权归"+_vm._s(_vm.option || '上海原圈科技')+"所有")])}
var staticRenderFns = []

export { render, staticRenderFns }